<script setup lang="ts">
// get all tip pages from content/tip

const { data: tipPages } = await useAsyncData('tip-pages21sq2222-2', async () => {
  return await queryCollectionNavigation('content')
    .where('pagetype', '=', 'tip-dutch')
})

const tipPageChildren = computed(() => {
  return tipPages.value?.[0]?.children ?? []
})

const links = computed(() => [
  {
    label: 'Home',
    to: '/',
  },
  {
    label: 'Populaire steden',
    to: '/makelaars/',
    children: [
      {
        label: 'Amsterdam',
        to: '/makelaars/noord-holland/amsterdam/',
      },
      {
        label: 'Rotterdam',
        to: '/makelaars/zuid-holland/rotterdam/',
      },
      {
        label: 'Den Haag',
        to: '/makelaars/zuid-holland/den-haag/',
      },
      {
        label: 'Utrecht',
        to: '/makelaars/utrecht/utrecht/',
      },
      {
        label: 'Eindhoven',
        to: '/makelaars/noord-brabant/eindhoven/',
      },
      {
        label: 'Groningen',
        to: '/makelaars/groningen/groningen/',
      },
      {
        label: 'Arnhem',
        to: '/makelaars/gelderland/arnhem/',
      },
      {
        label: 'Tilburg',
        to: '/makelaars/noord-brabant/tilburg/',
      },
      {
        label: 'Breda',
        to: '/makelaars/noord-brabant/breda/',
      },
      {
        label: 'Almere',
        to: '/makelaars/flevoland/almere/',
      },
      {
        label: 'Zwolle',
        to: '/makelaars/overijssel/zwolle/',
      },
      {
        label: 'Enschede',
        to: '/makelaars/overijssel/enschede/',
      },
    ],
  },
  {
    label: 'Advies en tips',
    to: '/tip',
    children: tipPageChildren.value?.map(tip => ({
      label: tip.title,
      to: tip.path,
    })) ?? [],
  },
  // {
  //   label: 'Huis verkopen',
  //   to: '/contact/',
  // },
  {
    label: 'Expat',
    to: 'https://juistemakelaar.com',
  },
])
</script>

<template>
  <UHeader>
    <template #left>
      <NuxtLink to="/">
        <NuxtImg
          src="/img/logo.webp"
          width="228"
          height="35"
          alt="Juiste makelaar"
        />
      </NuxtLink>
    </template>

    <template #right>
      <div class="hidden lg:block">
        <UNavigationMenu
          :items="links"
          class="hidden lg:block"
        />
      </div>
      <UButton
        label="Contact"
        to="/contact"
        color="success"
        class="hidden lg:flex"
      />
    </template>

    <template #body>
      <UNavigationMenu
        :items="links"
        orientation="vertical"
        class="-mx-2.5 "
      />
    </template>
  </UHeader>
</template>
